import React from 'react';
// import styles from '../homepage.module.css'
import styles from './why-choose-us.module.css'
import Lazy from "../../../common/lazy-scroll/Lazy";
import {HOME_PAGE_CONTENT} from "../homePageContent";

const WhyChooseUs: React.FC = () => {




    return (
        <section className={styles.section_container}>
            <div className={styles.content_wrapper}>
                <div className={styles.text_content}>
                    <h2 className={styles.section_title}>
                        {HOME_PAGE_CONTENT.whyChooseUs.sectionTitle}
                    </h2>
                    <p className={styles.intro_paragraph}>
                        {HOME_PAGE_CONTENT.whyChooseUs.paragraph}
                    </p>
                </div>
                <div className={styles.image_container}>
                    <Lazy
                        SrcImage={"/images/home/why_choose_us.jpg"}
                        className={styles.image}
                        alt={"Espace chaleureux de la garderie"}/>
                </div>
            </div>
        </section>
    );
};

export default WhyChooseUs;
